import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { IUserAuthenticationTokens } from "../types";

export interface IUserLoginMutationParameters {
    email: string;
    password: string;
}

export type IUserLoginMutationResult = IUserAuthenticationTokens;

export const userLoginMutation: IApiMutationFunction<IUserLoginMutationParameters> = ({ email, password }) => {
    return {
        method: "POST",
        url: "/login",
        data: {
            email,
            password,
        },
    };
};

export const useUserLoginMutation = createApiMutationHook<IUserLoginMutationParameters, IUserLoginMutationResult>(
    userLoginMutation,
);
